export type DaySchedule = {
  open: string // 'HH:mm' 24h format
  close: string // 'HH:mm' 24h format
} | null

export type RestaurantSchedule = {
  [dayIndex: number]: DaySchedule // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
}

// Hardcoded schedules for restaurants
export const RESTAURANT_SCHEDULES: Record<string, RestaurantSchedule> = {
  'capricho-de-canela': {
    0: { open: '00:00', close: '23:59' }, // Sunday
    1: { open: '00:00', close: '23:59' }, // Monday
    2: { open: '00:00', close: '23:59' }, // Tuesday
    3: { open: '00:00', close: '23:59' }, // Wednesday
    4: { open: '00:00', close: '23:59' }, // Thursday
    5: { open: '00:00', close: '23:59' }, // Friday
    6: { open: '00:00', close: '23:59' }, // Saturday
  },
  'heladeria-congelados': {
    0: { open: '13:00', close: '18:00' }, // Sunday
    1: { open: '10:00', close: '18:00' }, // Monday
    2: { open: '10:00', close: '18:00' }, // Tuesday
    3: { open: '10:00', close: '18:00' }, // Wednesday
    4: { open: '10:00', close: '17:00' }, // Thursday
    5: { open: '10:00', close: '18:00' }, // Friday
    6: { open: '10:00', close: '18:00' }, // Saturday
  },
  // Add other restaurants here as needed (Capricho = always open)
}

export function isRestaurantOpenBySchedule(slug: string | undefined): {
  isOpen: boolean
  hasSchedule: boolean
} {
  if (!slug || !RESTAURANT_SCHEDULES[slug]) {
    return { isOpen: false, hasSchedule: false }
  }

  const schedule = RESTAURANT_SCHEDULES[slug]

  // Get current time in Costa Rica timezone
  const now = new Date()

  // Use toLocaleString to get Costa Rica local time
  const crTimeStr = now.toLocaleString('en-US', {
    timeZone: 'America/Costa_Rica',
  })
  const crDate = new Date(crTimeStr)

  const currentDay = crDate.getDay() // 0 = Sunday, 1 = Monday, etc.
  const currentHour = crDate.getHours()
  const currentMinute = crDate.getMinutes()

  const currentTimeNum = currentHour * 60 + currentMinute
  const todaySchedule = schedule[currentDay]

  if (!todaySchedule) {
    return { isOpen: false, hasSchedule: true }
  }

  // Parse open/close times into minutes since midnight
  const [openHour, openMinute] = todaySchedule.open.split(':').map(Number)
  const [closeHour, closeMinute] = todaySchedule.close.split(':').map(Number)

  const openTimeNum = openHour * 60 + openMinute
  const closeTimeNum = closeHour * 60 + closeMinute

  // Check if current time is within operating hours
  const isOpen = currentTimeNum >= openTimeNum && currentTimeNum < closeTimeNum

  return { isOpen, hasSchedule: true }
}
